/**
 * Created by Andrey Popov on 08.12.2025
 */

const Singleton = function (unit) {
    UnitComponent.call(this, unit);
};

Singleton.prototype = Object.create(UnitComponent.prototype);
Singleton.prototype.constructor = Singleton;

Singleton.prototype.kickOut = function () {
    const unit = this.unit.head || this.unit;
    unit.remove();
    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation.pocket) {
        Map2dLocation.currentLocation.pocket.addUnits(unit);
    }
};

Singleton.prototype.moveFromPoint = function (x, y) {
    const empty = Map2d.currentMap.findEmptySlot(x, y, this.unit, {
        skipCheckEqual: true
    });

    if (empty) {
        this.unit.setPosition(empty.x, empty.y);
        this.unit.onMove({ isPushed: true });
    } else {
        this.unit.remove();
        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation.pocket) {
            Map2dLocation.currentLocation.pocket.addUnits(this.unit, this.unit);
        }
    }
};

Singleton.prototype.handleRemove = function () {
    if (this.unit.isLifted()) {
        return;
    }

    const map = Map2d.currentMap;
    const unit = this.unit;
    const mapUnit = map.getUnit(unit.x, unit.y);

    if (!mapUnit || mapUnit !== unit) {
        if (cleverapps.config.debugMode) {
            console.log(unit, mapUnit);
            throw "Cant be! ";
        }
    }

    map.remove(Map2d.LAYER_UNITS, unit.x, unit.y);

    let wasIntact = false;
    if (unit.intact) {
        wasIntact = true;
        unit.intact = undefined;
    }

    unit.removeFromMap(wasIntact);
};